































































































import PaperPlanIcon from '@/app/ui/assets/paper_plane_icon.vue'
import ListIcon from '@/app/ui/assets/list_icon.vue'
import dayjs from 'dayjs'
import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjsDuration from 'dayjs/plugin/duration'
import { Utils } from '@/app/infrastructures/misc'

interface Pickup {
  flag: string
  bookingId: string
  doOriginPackageId: string
  isDedicated: boolean
  shipmentId: string
  groupId: string
  productType: string
  isOnepack: boolean
  pickup: {
    fullname: string
    phoneNumber: string
    latitude: number
    longitude: number
    address: string
  }
  courierPickupDetail: {
    courierId: string
    courierName: string
    courierTypeValid: string
    phoneNumber: string
    partnerName: string
  }
  createdAt: string
  history: {
    actorId: string,
    reason: string,
    createdAt: string
    actorName: string
  }
  shipmentType: string
}

dayjs.extend(dayjsDuration)

@Component({
  components: {
    PaperPlanIcon,
    ListIcon,
  },
})
export default class PickupItemCRROTW extends Vue {
  @Prop({ required: true }) public no!: number
  @Prop({ required: true }) public data!: Pickup

  get date(): string {
    return Utils.formatDateWithIDLocale(
      this.data.history.createdAt,
      'DD-MMM-YYYY',
    )
  }

  get time(): string {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(
        this.data.history.createdAt,
        'HH:mm Z'
      )
    )
  }

  get duration(): string {
    const duration = dayjs.duration(dayjs().diff(dayjs(this.data.createdAt)))

    const result = []

    //Get Days
    const days = Math.floor(duration.asDays())
    if (days) {
      result.push(`${days}d`)
    }

    //Get Hours
    const hours = duration.hours()
    if (hours) {
      result.push(`${hours}h`)
    }

    //Get Minutes
    const minutes = duration.minutes()
    result.push(`${minutes}m`)

    return result.join(', ')
  }

  get hasCourierPickupDetail(): boolean {
    return !!this.data.courierPickupDetail
  }

  get courier(): string {
    if (this.hasCourierPickupDetail) {
      const courierPickupDetail = this.data.courierPickupDetail
      return `${courierPickupDetail?.courierTypeValid}-${courierPickupDetail?.courierName} (${courierPickupDetail?.phoneNumber})`
    }

    return this.data.history.actorName
  }

  get overSLA(): boolean {
    return dayjs().diff(dayjs(this.data.createdAt), 'hours') >= 48
  }

  get isBosspack(): boolean {
    return this.data.productType === 'BOSSPACK'
  }
}
